export const locales=[
	"en-us", "en-ca", "en-ie", "en-gb", "en-se", "en-il", "en-ap", 
	"en-au", "en-sg", "en-in", "de-de", "de-at", "fr-fr", "fr-ca", 
	"cs-cz", "es-es", "el-gr", "it-it", "nl-nl", "pl-pl", "es-la", 
	"pt-br", "zh-cn", "zh-tw", "ko-kr", "ja-jp", "th-th", "in-id", 
	"ru-ru", "ar-sa", "tr-tr", "be-by", "hr-hr",  'en-ae','en-kw', 
	'en-kz', 'en-za', "id-id", "en-ua"
  ];